import {
  faPencilAlt,
  faRotateRight,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { B2Button } from "@hdb/biome-2";
import { useQuery } from "@tanstack/react-query";
import * as _ from "lodash";
import { createRef, useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getUserInfo } from "src/core/auth/auth.service";
import { displayToast } from "src/shared/helpers/toaster.helper";
import * as yup from "yup";
import circleCheck from "../../../../../../assets/images/circle-check.png";
import circleCross from "../../../../../../assets/images/circle-cross.png";
import { getGatewayGroup } from "../../../../../../core/api/services/asset/gateway-group.service";
import {
  getOperationMode,
  getTimerProfile,
} from "../../../../../../core/api/services/asset/light-profile/timer-profile.service";
import MfaComponent from "../../../../../../core/components/mfa/mfa.component";
import ModalComponent from "../../../../../../core/components/modal/modal.component";
import TableComponent from "../../../../../../core/components/table/table.component";
import { AssetCommandEnums } from "../../../../../../core/enums/assetCommands-enums";
import HasPermission from "../../../../../../core/guards/has-permission";
import FormBuilderComponent, {
  FormConfig,
} from "../../../../../../shared/form-builder/form-builder.component";
import { safeAtob } from "../../../../../../shared/helpers/enode-decode-string";
import TableSort from "../../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../../shared/helpers/upper-case";
import {
  deleteTimerProfile,
  enableOrDisableTimerProfile,
  getDaysOfWeek,
  getTimerProfileByCode,
  postTimerProfile,
  resetTimerProfile,
  sendGetCommandToDms,
  updateTimerProfile,
} from "../../../../../../store/slices/asset.slice";
import { setOtpIsValidation } from "../../../../../../store/slices/mfa-otp.slice";

const OldTimerProfileComponent = () => {
  const dispatch = useDispatch();
  const params: any = useParams();
  const id = params.id ? safeAtob(params.id) : null;
  const formRef = createRef();
  // const repeatActionFormRef = createRef();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEnableProfile, setIsEnableProfile] = useState<boolean | null>(null);
  const [groupOptions, setGroupOptions] = useState<any>([]);
  const [actionOptions, setActionOptions] = useState([]);
  // const [currentFeature, setCurrentFeature] = useState("" as any);
  const [isOTPModalOpen, setIsOTPModalOpen] = useState<boolean>(false);
  const [isRefreshing, setIsRefreshing] = useState<boolean>(false);
  const [selectedIdToDeleteOrEdit, setSelectedIdToDeleteOrEdit] =
    useState<number>(0);

  const [isRepeatActionModalOpen, setIsRepeatActionModalOpen] =
    useState<boolean>(false);
  const user = getUserInfo();

  const socketData = useSelector((state: any) => {
    return state.asset.socketData;
  });

  const mfaInfo = useSelector((state: any) => {
    return state.user.mfaInfo;
  });

  const socketRealTimeUpdate = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdate;
  });

  const socketRealTimeUpdateData = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdateData;
  });

  const { data: gatewayGroups } = useQuery({
    queryKey: ["getGatewayGroup", id],
    queryFn: () => getGatewayGroup(id!),
    enabled: isModalOpen,
  });

  const { data: operationModes } = useQuery({
    queryKey: ["getOperationMode"],
    queryFn: () => getOperationMode(),
    enabled: isModalOpen,
  });

  useEffect(() => {
    const groups = gatewayGroups?.data?.map((group: any) => ({
      value: group?.zoneId,
      label: group?.groupName + ` (Zone - ${group?.zoneId})`,
    }));

    setGroupOptions(groups);
  }, [gatewayGroups]);

  useEffect(() => {
    const modes = operationModes?.data?.map((mode: any) => ({
      value: mode?.id,
      label: mode?.name,
    }));

    setActionOptions(modes);
  }, [operationModes]);

  const [pageNumber, setPageNumber] = useState<number>(1);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isDetails, setIsDetails] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<any>({
    profileName: "",
    startTime: "",
    endTime: "",
    zoneID: "",
    actionId: "",
    daysOfWeeks: "",
    dimLevel: "",
    brightLevel: "",
  });

  /*   const [repeatActionInitialValues, setRepeatActionInitialValues] =
    useState<any>({
      repeatAction: 30,
    }); */

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("profileName"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  // const [binaryChartData, setBinaryChartData] = useState<any>();
  useEffect(() => {
    dispatch({
      type: "table/toggleSelectAll",
      payload: [],
    });
  }, [dispatch]);

  const daysOfWeek = useSelector((state: any) => {
    return state.asset.daysOfWeek;
  });

  const timerProfile = useSelector((state: any) => {
    return state.asset.timerProfileDetails;
  });

  const [daysOfWeekOptions, setDaysOfWeekOptions] = useState<any>([]);

  useEffect(() => {
    if (timerProfile && Object.keys(timerProfile).length > 0) {
      const data = {
        profileName: timerProfile?.profileName || null,
        startTime: timerProfile?.startTime || null,
        endTime: timerProfile?.endTime || null,
        zoneID: timerProfile?.zoneId || 0,
        actionId: Number(timerProfile?.action || null),
        daysOfWeeks: Number(timerProfile?.dayOfWeek || null),
        dimLevel: timerProfile?.dimLevel || 0,
        brightLevel: timerProfile?.brightLevel || 0,
      };

      setInitialValues(data);
    }
  }, [timerProfile]);

  useEffect(() => {
    const days = daysOfWeek?.map((day: any) => ({
      value: day?.id,
      label: day?.name,
    }));

    setDaysOfWeekOptions(days);
  }, [daysOfWeek]);

  const [columns, setColumns] = useState([
    {
      title: "Profile Name",
      label: "profileName",
      isSorted: true,
      // width: "8rem"
    },
    {
      title: "Time",
      label: "startTime",
      // width: "10rem"
    },
    {
      title: "Dim Level (%)",
      label: "dimLevel",
    },
    {
      title: "Bright Level (%)",
      label: "brightLevel",
    },
    {
      title: "Group",
      label: "group",
    },
    {
      title: "Light Action",
      label: "action",
    },
    {
      title: "Status",
      label: "status",
    },
    {
      title: "Day Of Weeks",
      label: "dayOfWeek",
      // width: "13rem"
    },
  ]);

  const pageSize = 10;

  const formConfig: FormConfig = {
    controls: [
      {
        name: "profileName",
        label: "Profile Name",
        placeholder: "Profile Name",
        type: "text",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "startTime",
        label: "Start Time",
        placeholder: "Start Time",
        type: "time",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "endTime",
        label: "End Time",
        placeholder: "End Time",
        type: "time",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "zoneID",
        label: "Group",
        placeholder: "Select Group",
        type: "select",
        options: groupOptions,
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "daysOfWeeks",
        label: "Days Of Week",
        placeholder: "Select Days Of Week",
        type: "select",
        options: daysOfWeekOptions,
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "actionId",
        label: "Action",
        placeholder: "Select Action",
        type: "select",
        options: actionOptions,
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "dimLevel",
        label: "Dim Level (%)",
        placeholder: "e.g: 12",
        type: "number",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "brightLevel",
        label: "Bright Level (%)",
        placeholder: "e.g: 80",
        type: "number",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
    ],
  };

  /*   const repeatActionFormConfig: FormConfig = {
    controls: [
      {
        name: "repeatAction",
        label: "Repeat Action",
        placeholder: "Repeat Action",
        type: "number",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
    ],
  }; */

  const selectedItems = useSelector((state: any) => state.table.selectedItems);

  const {
    data: timerProfiles,
    isLoading: isLoadingTimeProfiles,
    refetch: refetchTimerProfile,
  } = useQuery({
    queryKey: [
      "getTimerProfile",
      pageSize,
      pageNumber,
      SortBy,
      SortDirection,
      id,
    ],
    queryFn: () =>
      getTimerProfile(pageSize, pageNumber, SortBy, SortDirection, id),
  });

  const showToaster = (socketRealTimeUpdateData: any) => {
    if (
      user[
      "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
      ] === socketData?.NotificationIdentifier
    ) {
      displayToast(
        socketRealTimeUpdateData?.PushMessage || "Acknowledgement Received",
        socketRealTimeUpdateData?.ToasterColor
      );
    }
  };

  useEffect(() => {
    const copiedSocketRealTimeUpdate = _.cloneDeep(socketRealTimeUpdate);

    if (copiedSocketRealTimeUpdate.TimerProfile) {
      showToaster(socketRealTimeUpdateData);
      void refetchTimerProfile();
      // setOnRefetchEnabled(true);
    }
  }, [socketRealTimeUpdate]); // socketRealTimeUpdateData

  /*   useEffect(() => {
      const chartData = timerProfiles?.data
        ?.map((item: any) => {
          const startTime = parseFloat(
            item.startTime.split("-")[0].replace(/:/g, ".")
          );
          const endTime = parseFloat(item.endTime.replace(/:/g, "."));
          const status = item.status === "Enabled" ? 1 : 0;
  
          if (status) {
            return { x: [startTime, endTime], y: status };
          }
        })
        .filter((dataPoint: any) => dataPoint !== undefined);
  
      // setBinaryChartData(chartData);
    }, [timerProfiles]); */

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsEdit(false);
    setIsDetails(false);
    setIsDelete(false);
    setIsOTPModalOpen(false);
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNumber(page);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  const onSubmit = () => {
    const form: any = formRef.current;

    if (form) {
      form.handleSubmit();

      const {
        profileName,
        startTime,
        endTime,
        zoneID,
        actionId,
        daysOfWeeks,
        dimLevel,
        brightLevel,
      } = form.values;

      const trimmedProfileName = profileName.trim();

      // Validate dimLevel and brightLevel
      const isValidDimLevel =
        dimLevel != null && // Not null or undefined
        dimLevel !== "" && // Not empty string
        Number.isInteger(Number(dimLevel)) &&
        Number(dimLevel) >= 0 &&
        Number(dimLevel) <= 100;
      const isValidBrightLevel =
        brightLevel != null && // Not null or undefined
        brightLevel !== "" && // Not empty string
        Number.isInteger(Number(brightLevel)) &&
        Number(brightLevel) >= 0 &&
        Number(brightLevel) <= 100;

      if (
        !trimmedProfileName ||
        trimmedProfileName?.length > 50 ||
        !startTime ||
        !endTime ||
        !zoneID ||
        !actionId ||
        !daysOfWeeks ||
        !isValidDimLevel ||
        !isValidBrightLevel
      ) {
        return;
      }

      const data = {
        ...form.values,
        daysOfWeek: Number.parseInt(form.values.daysOfWeek),
        actionId: Number.parseInt(form.values.actionId),
        assetCode: id,
        id: selectedIdToDeleteOrEdit,
        profileControl: "",
        dimLevel: Number.parseInt(form.values.dimLevel),
        brightLevel: Number.parseInt(form.values.brightLevel),
      };

      if (isEdit) {
        void dispatch(updateTimerProfile({ body: data })).then(() =>
          refetchTimerProfile(),
        );
      } else {
        void dispatch(postTimerProfile({ body: data })).then(() =>
          refetchTimerProfile(),
        );
      }
    }

    handleCloseModal();
  };
  //
  const editAction = (id: number) => {
    dispatch(getDaysOfWeek());

    dispatch(getTimerProfileByCode({ timerProfileId: id })).then(() => {
      setIsEdit(true);
      setIsModalOpen(true);
      setIsDetails(false);
      setIsDelete(false);
    });

    setSelectedIdToDeleteOrEdit(id);
  };

  const handleAdd = () => {
    dispatch(getDaysOfWeek());

    setInitialValues({
      profileName: "",
      startTime: "",
      endTime: "",
      zoneID: "",
      actionId: "",
      daysOfWeeks: "",
      dimLevel: "",
      brightLevel: "",
    });

    setIsDetails(false);
    setIsModalOpen(true);
    setIsEdit(false);
    setIsDelete(false);
  };

  const handleRefresh = () => {
    setIsRefreshing(true);
    dispatch(
      sendGetCommandToDms({
        assetCode: id,
        module: Number(AssetCommandEnums.TimerProfile),
      })
    )
      .then(() => {
        refetchTimerProfile()
          .then(() => {
            setIsRefreshing(false);
          })
          .catch(() => {
            setIsRefreshing(false);
          });
      })
      .catch(() => {
        setIsRefreshing(false);
      });
  };

  /*   const handleReset = () => {
    // setCurrentFeature("reset");

    if (mfaInfo?.isDMSMfaEnabled) {
      setIsOtpModalOpen(true);
    } else {
      onSubmitMfaOtp("reset");
    }
  }; */

  const handleProfileEnableDisable = (isEnable: boolean) => {
    setIsEnableProfile(isEnable);
    const ids = selectedItems?.map((item: any) => item?.value);

    if (ids?.length <= 0) {
      return;
    }

    if (mfaInfo?.isDMSMfaEnabled) {
      setIsOTPModalOpen(true);
    } else {
      onSubmitMfaOtp("enableOrDisable", isEnable);
    }
  };

  const onSubmitMfaOtp = (currentFeature: string, isEnable?: boolean) => {
    switch (currentFeature) {
      case "reset":
        dispatch(resetTimerProfile({ assetCode: id }));
        break;
      case "enableOrDisable":
        if (!isEnable) {
          const ids = selectedItems
            ?.map((item: any) => item?.value)
            .filter((item: any) => item !== null);

          dispatch(
            enableOrDisableTimerProfile({
              body: { nums: ids },
              isEnable: isEnable,
            })
          ).then(() => {
            dispatch({
              type: "table/toggleSelectAll",
              payload: [],
            });

            dispatch({
              type: "table/toggleSelect",
              payload: { page: null, value: null, status: null },
            });
          });
        } else {
          setIsRepeatActionModalOpen(true);
        }
        break;
      default:
        break;
    }

    dispatch(setOtpIsValidation(false));
    handleCloseModal();
  };

  const onSubmitRepeatAction = () => {
    // const form: any = repeatActionFormRef.current;

    /*     if (form) {
      form.handleSubmit();

      setRepeatActionInitialValues({
        repeatAction: form.values.repeatAction,
      }); */

    const ids = selectedItems
      ?.map((item: any) => item?.value)
      .filter((item: any) => item !== null);

    dispatch(
      enableOrDisableTimerProfile({
        body: { nums: ids },
        isEnable: isEnableProfile,
        repeatAction: 0,
      })
    ).then(() => {
      dispatch({
        type: "table/toggleSelectAll",
        payload: [],
      });

      dispatch({
        type: "table/toggleSelect",
        payload: { page: null, value: null, status: null },
      });
    });
    setIsRepeatActionModalOpen(false);
    // }
  };

  const validationSchema = yup.object().shape({
    profileName: yup
      .string()
      .trim()
      .required("Profile Name is required")
      .max(50, "Profile Name must be at most 50 characters"),
    startTime: yup.string().required("Start Time is required"),
    endTime: yup.string().required("End Time is required"),
    zoneID: yup.string().required("Zone is required"),
    actionId: yup.string().required("Action is required"),
    daysOfWeeks: yup.string().required("Days Of Weeks is required"),
    dimLevel: yup
      .number()
      .typeError("Dim Level must be a number")
      .required("Dim Level is required")
      .integer("Dim Level must be an integer")
      .min(0, "Dim Level must be at least 0")
      .max(100, "Dim Level must be at most 100"),
    brightLevel: yup
      .number()
      .typeError("Bright Level must be a number")
      .required("Bright Level is required")
      .integer("Bright Level must be an integer")
      .min(0, "Bright Level must be at least 0")
      .max(100, "Bright Level must be at most 100"),
  });

  // const repeatActionValidation = yup.object().shape({});

  const isOtpVerified = useSelector((state: any) => {
    return state.otp.isOtpVerified;
  });

  const handleCloseOtpModal = () => {
    setIsOTPModalOpen(false);
  };

  const handleCloseRepeatActionModal = () => {
    setIsRepeatActionModalOpen(false);
  };

  const deleteAction = (timerProfileId: any) => {
    setIsDetails(false);
    setIsModalOpen(true);
    setIsEdit(false);
    setIsDelete(true);

    setSelectedIdToDeleteOrEdit(timerProfileId);
  };

  const handleDelete = () => {
    dispatch(
      deleteTimerProfile({ timerProfileId: selectedIdToDeleteOrEdit })
    ).then(() => {
      void refetchTimerProfile();
      handleCloseModal();
    });
  };

  function isDisplayButton(data: any, label: any): boolean {
    if (data?.isBaseProfile) {
      return false;
    }
    return true;
  }

  const modalActionConfig = isDetails
    ? []
    : isDelete
      ? [
        {
          label: "Yes",
          event: handleDelete,
          variant: "primary",
        },
      ]
      : [
        {
          label: "Save",
          event: onSubmit,
          variant: "primary",
        },
      ];

  const mfaActionConfig: any = [
    {
      label: "Save",
      event: onSubmitMfaOtp,
      variant: "primary",
      disabled: !isOtpVerified,
    },
  ];

  const RepeatActionConfig: any = [
    /*     {
      label: "Save",
      event: onSubmitRepeatAction,
      variant: "primary",
    }, */
    {
      label: "Yes",
      event: onSubmitRepeatAction,
      variant: "primary",
    },
  ];

  const actionConfig: any = [
    {
      label: "Edit",
      actionProperty: "id",
      event: editAction,
      variant: "secondary",
      className: "mx-2 my-1",
      icon: faPencilAlt,
      moduleName: "Timer Profile",
      actionName: "Edit-Timer Profile",
    },
    {
      label: "Delete",
      actionProperty: "id",
      event: deleteAction,
      isDisplay: isDisplayButton,
      variant: "danger",
      className: "mx-2 my-1",
      icon: faTrashAlt,
      moduleName: "Timer Profile",
      actionName: "Delete-Timer Profile",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Timer Profile | Asset</title>
      </Helmet>
      <div>
        <div className="bg-card">
          {/* <div className="d-flex justify-content-end table-generic-action">
            <HasPermission
              moduleName="Timer Profile"
              actionName="Add-Timer Profile"
              isRoute={false}
            >
              <div className="d-flex justify-end items-end">
                <B2Button
                  className=""
                  variant="default"
                  onClick={handleRefresh}
                >
                  <FontAwesomeIcon icon={faRotateRight} className="fs-7 me-2" />
                  Refresh
                </B2Button>
              </div>
            </HasPermission>
          </div> */}

          {/* <div className="my-3">
            {binaryChartData?.length ? (
              <CustomBinaryChart
                xAxisCategories={null}
                xAxisMin={0}
                xAxisMax={23}
                SeriesType={"column"}
                seriesData={binaryChartData}
                seriesShowInLegend={false}
                xAxisTitleText={"Time (Hours)"}
                yAxisTitleText={"Status"}
                colors={["#3B1DCD"]}
                xAxisTimeFormatter={true}
              />
            ) : null}
          </div> */}

          <div className="my-3">
            <div className="d-flex justify-content-end table-generic-action">
              <HasPermission
                moduleName="Timer Profile"
                actionName="Add-Timer Profile"
                isRoute={false}
              >
                <div className="d-flex justify-end items-end">
                  {/*                   <B2Button
                    className=""
                    variant="default"
                    onClick={handleReset}
                  >
                    <img
                      src={resetBtn}
                      alt="reset"
                      height={"20px"}
                      className="me-2"
                    />
                    Reset
                  </B2Button> */}

                  <B2Button
                    className=""
                    variant="default"
                    onClick={handleRefresh}
                  >
                    <FontAwesomeIcon
                      icon={faRotateRight}
                      className="fs-7 me-2"
                    />
                    Refresh
                  </B2Button>

                  <B2Button variant="primary" onClick={handleAdd}>
                    Add Timer Profile
                  </B2Button>
                </div>
              </HasPermission>
            </div>
            <div className="mt-3">
              <TableComponent
                tableHeaders={columns}
                data={timerProfiles?.data}
                totalNumberOfRecords={timerProfiles?.numberOfRecords}
                pageSize={pageSize}
                current={pageNumber}
                actionConfig={actionConfig}
                onChangePage={handleChangePage}
                onChangeSort={handleChangeSort}
                enableSelection={true}
                isLoadingData={isLoadingTimeProfiles || isRefreshing}
                count={5}
                wrapperHeight="350px"
                moduleName="Timer Profile"
                actionName="Edit-Timer Profile"
              />
            </div>
          </div>

          {timerProfiles?.numberOfRecords > 0 && (
            <div className="my-3 d-flex justify-content-start align-items-center gap-3  table-generic-action">
              <HasPermission
                moduleName="Timer Profile"
                actionName="Enable-Timer Profile"
                isRoute={false}
              >
                <B2Button
                  className="d-flex justify-content-center align-items-center "
                  variant="default"
                  onClick={() => handleProfileEnableDisable(true)}
                >
                  <img
                    src={circleCheck}
                    alt="enable"
                    height={"20px"}
                    className="me-2"
                  />
                  Enable Profile
                </B2Button>
              </HasPermission>

              <HasPermission
                moduleName="Timer Profile"
                actionName="Disable-Timer Profile"
                isRoute={false}
              >
                <B2Button
                  className="d-flex justify-content-center align-items-center "
                  variant="default"
                  onClick={() => handleProfileEnableDisable(false)}
                >
                  <img
                    src={circleCross}
                    alt="disable"
                    height={"20px"}
                    className="me-2"
                  />
                  Disable Profile
                </B2Button>
              </HasPermission>
            </div>)}

        </div>

        {/* modals */}
        {isModalOpen && (
          <ModalComponent
            showModal={isModalOpen}
            handleClose={handleCloseModal}
            headerTitle={
              isEdit
                ? "Edit Timer Profile"
                : isDetails
                  ? "Timer Profile Details"
                  : isDelete
                    ? "Delete Timer Profile"
                    : "Add Timer Profile"
            }
            actionConfig={modalActionConfig}
          >
            {isDelete ? (
              <h5 className="text-center">
                Are you sure to <b className="text-danger">Delete</b>?
              </h5>
            ) : (
              <FormBuilderComponent
                formRef={formRef}
                validation={validationSchema}
                initialValues={initialValues}
                formConfig={formConfig}
              />
            )}
          </ModalComponent>
        )}

        {isOTPModalOpen && (
          <ModalComponent
            showModal={isOTPModalOpen}
            handleClose={handleCloseOtpModal}
            actionConfig={mfaActionConfig}
            headerTitle={"Multi Factor Authentication"}
            isViewMode={false}
          >
            <MfaComponent />
          </ModalComponent>
        )}

        {isRepeatActionModalOpen && (
          <ModalComponent
            showModal={isRepeatActionModalOpen}
            handleClose={handleCloseRepeatActionModal}
            actionConfig={RepeatActionConfig}
            headerTitle={"Command Issue"}
          >
            {/*             <FormBuilderComponent
              formRef={repeatActionFormRef}
              validation={repeatActionValidation}
              initialValues={repeatActionInitialValues}
              formConfig={repeatActionFormConfig}
            /> */}
            <h5 className="text-center">
              Are you sure, you want to{" "}
              <b className="text-danger">Enable Profile</b>?
            </h5>
          </ModalComponent>
        )}
      </div>
    </>
  );
};

export default OldTimerProfileComponent;
